module.exports = __webpack_public_path__ + "img/logistic-station.8f4ba32e.png";